import React from 'react'
import logoIcon from '../../assets/icons/sidebarIcons/logoIcon.svg';
import arrowIcon from '../../assets/icons/common/arrowIcon.svg'; 
const SidebarHeader = () => {
  return (
    <div className='flex items-center justify-between flex-wrap'>
        <div>
            <img src={logoIcon} alt='logo'/>
        </div>
        <div className='bg-[white] p-[4px] rounded-[12px] cursor-pointer'>
            <img src={arrowIcon} alt='arrow'/>
        </div>
    </div>
  )
}

export default SidebarHeader